import { TypedDocumentNode, gql } from '@apollo/client';
import { ComponentProps } from 'react';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';

import { DivisionChangeStory } from 'components/so5/LastFixtureStory/DivisionChangeStory';
import { useResultsStoryAssets } from 'components/so5/LastFixtureStory/useResultsStoryAssets';

import { Promotion_so5Fixture } from './__generated__/index.graphql';

type Props = {
  so5Fixture: Promotion_so5Fixture;
  onNext?: ComponentProps<typeof DivisionChangeStory>['onNext'];
  onClose: ComponentProps<typeof DivisionChangeStory>['onClose'];
};

export const Promotion = ({ so5Fixture, onNext, onClose }: Props) => {
  const { introToPromotion, promotionOut } = useResultsStoryAssets();
  return (
    <DivisionChangeStory
      so5Fixture={so5Fixture}
      onNext={onNext}
      onClose={onClose}
      introVideo={introToPromotion}
      outroVideo={promotionOut}
      divisionChange={DivisionChange.PROMOTED}
    />
  );
};

Promotion.fragments = {
  so5Fixture: gql`
    fragment Promotion_so5Fixture on So5Fixture {
      slug
      ...DivisionChangeStory_so5Fixture
    }
    ${DivisionChangeStory.fragments.so5Fixture}
  ` as TypedDocumentNode<Promotion_so5Fixture>,
};
